/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { ImportExternalDocRequest } from '../types/ImportExternalDoc';
import type { ImportExternalDocResponse } from '../types/ImportExternalDoc';

export type BrnoDocsImportExternalDocsCreateRequest = ImportExternalDocRequest;
export type BrnoDocsImportExternalDocsCreateResponse = ImportExternalDocResponse;

export type BrnoDocsImportExternalDocsCreateQuery = {};

/**
 * POST /dmx-server/brno_docs/import_external_docs/
 *
 * ```yaml
 * operationId: brno_docs_import_external_docs_create
 * description: >-
 *   You can order docs using GET param ordering_state
 *
 *   example:
 *
 *   http://localhost/dmx-server/docs_reduced/?ordering_state=CANCELED,SUBMITTED,REJECTED,ACCEPTED
 *
 *   At first all CANCELED docs, then all with state SUBMITTED, then REJECTED, etc.
 * tags:
 *   - brno_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/ImportExternalDoc'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/ImportExternalDoc'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/ImportExternalDoc'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/ImportExternalDoc'
 *     description: ''
 * ```
 */
export const brnoDocsImportExternalDocsCreateOperation = (
  rest?: BrnoDocsImportExternalDocsCreateQuery | null,
) =>
  ({
    method: 'POST',
    path: `/dmx-server/brno_docs/import_external_docs/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/brno_docs/import_external_docs/' };
  };

/**
 * POST /dmx-server/brno_docs/import_external_docs/
 *
 * ```yaml
 * operationId: brno_docs_import_external_docs_create
 * description: >-
 *   You can order docs using GET param ordering_state
 *
 *   example:
 *
 *   http://localhost/dmx-server/docs_reduced/?ordering_state=CANCELED,SUBMITTED,REJECTED,ACCEPTED
 *
 *   At first all CANCELED docs, then all with state SUBMITTED, then REJECTED, etc.
 * tags:
 *   - brno_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/ImportExternalDoc'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/ImportExternalDoc'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/ImportExternalDoc'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/ImportExternalDoc'
 *     description: ''
 * ```
 */
export const brnoDocsImportExternalDocsCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: BrnoDocsImportExternalDocsCreateQuery;
  request: ImportExternalDocRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<ImportExternalDocResponse>> => {
  const operation = brnoDocsImportExternalDocsCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
